import { gql, useQuery } from '@apollo/client'

const GET_TICKET_BY_ID = gql`
query getTicketById($ticketId: Uuid = "") {
    ticketsById(id: $ticketId) {
        ticketUpdates(order_by: {createdAt: Asc}) {
            comment
            createdAt
            id
            ticketId
            updatedBy
        }
        assignedTo
        createdAt
        description
        status
        priority
        id
        title
        type
        updatedAt
    }
}
`

const useFetchTicketById = (ticketId) => {
    const { data, loading, error, refetch } = useQuery(GET_TICKET_BY_ID, {
        context: {
            headers: {
                'x-hasura-role': 'learner'
            }
        },
        variables: { ticketId },
        skip: !ticketId
    })

    return { data: data?.ticketsById, loading, error, refetch }
}

export default useFetchTicketById
